import React, { Component } from 'react';
import PropTypes from 'prop-types';

// MUI Components
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import DialogTitle from '@material-ui/core/DialogTitle';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

// MUI Icons
import { default as AddIntermissionIcon } from '@material-ui/icons/Timer';
import { default as RemoveIntermissionIcon } from '@material-ui/icons/TimerOff';

class IntermissionButton extends Component {
  constructor(props) {
    super(props);

    this.handlePress = this.handlePress.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleRemoveIntermission = this.handleRemoveIntermission.bind(this);

    this.state = { showModel: false };
  }
  handlePress() {
    this.setState({ showModel: true });
  }

  handleConfirm() {
    const { units, teachingPeriodIndex, removeIntermissionUnit } = this.props;

    //Remove all units within teachingPeriod before setting as intermission
    for (let i = 0; i < units.length; i++) {
      const unit = units[i];
      if (unit) {
        removeIntermissionUnit(teachingPeriodIndex, i);
      }
    }

    this.props.setIntermission(this.props.teachingPeriodIndex);
    this.setState({ showModel: false });
  }

  handleCancel() {
    this.setState({ showModel: false });
  }

  handleRemoveIntermission() {
    this.props.unsetIntermission(this.props.teachingPeriodIndex);
  }

  render() {
    /**
     * Goes through all the units and filters out any Free Elective or null unit, so they can be displayed in the modal
     */
    let IDcount = 0;

    const unitsToDelete = this.props.units.map(
      data =>
        data && data.unitCode ? `${data.unitCode} - ${data.unitName}` : null,
    );

    const filteredUnitsToDelete = unitsToDelete.filter(x => x != null);
    /**
     * Message displayed in modal
     */
    const disclaimer = (
      <p>
        This will set this teaching period as an intermission period, to take an
        intermission you will need to consult your faculty. For more information
        on intermission periods visit the{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.monash.edu/enrolments/change/intermission">
          Monash intermission information page
        </a>
      </p>
    );

    const message =
      filteredUnitsToDelete.length === 0 ? (
        <React.Fragment>{disclaimer}</React.Fragment>
      ) : (
        <React.Fragment>
          {disclaimer}
          <p>
            Setting this Teaching Period to Intermission will delete the
            following units from your course plan:
          </p>
          <ul>
            {filteredUnitsToDelete.map(item => {
              return <li key={item + IDcount++}>{item}</li>;
            })}
          </ul>
        </React.Fragment>
      );
    if (!this.props.isIntermission && this.state.showModel) {
      return (
        <Dialog open={true}>
          <DialogTitle>
            Are you sure you want to set this teaching period to an
            Intermission?
          </DialogTitle>
          <DialogContent>{message}</DialogContent>
          <DialogActions>
            <Button
              aria-label="Cancel"
              color="primary"
              onClick={() => {
                this.handleCancel();
                this.props.closeMenu();
              }}>
              Cancel
            </Button>
            <Button
              arial-label="Yes"
              color="primary"
              onClick={() => {
                this.handleConfirm();
                this.props.closeMenu();
              }}>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      );
    }
    /**
     * Insert Intermission Button
     */
    if (!this.props.isIntermission) {
      return (
        <MenuItem
          disabled={this.props.isIntermission}
          onClick={() => {
            this.handlePress();
          }}
          aria-label="Mark as Intermission">
          <ListItemIcon>
            <AddIntermissionIcon />
          </ListItemIcon>
          <ListItemText>Mark as Intermission</ListItemText>
        </MenuItem>
      );
    }
    /**
     * Remove Intermission
     */
    return (
      <MenuItem
        disabled={!this.props.isIntermission}
        onClick={() => {
          this.handleRemoveIntermission();
          this.props.closeMenu();
        }}
        aria-label="Remove Intermission">
        <ListItemIcon>
          <RemoveIntermissionIcon />
        </ListItemIcon>
        <ListItemText>Remove Intermission</ListItemText>
      </MenuItem>
    );
  }
}

export default IntermissionButton;

IntermissionButton.propTypes = {
  teachingPeriodIndex: PropTypes.number,
  isIntermission: PropTypes.bool,
  year: PropTypes.number,
  units: PropTypes.array.isRequired,
};
